import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useConfigurationNavigationMatch } from "@plansoft-configuration-renderer/framework";
/**
 * Attempts to restore scroll position in a configuration
 *
 * Scenario
 * - use navigated to a sub configuration from the parent
 * - user returns to the parent configuration object
 * - after returning, this component scrolls to instance where the navigation was initiated
 *
 * For this to work, the sub configuration instance needs an element with an id equal to the attribute path in the document
 *
 * @category Behavior
 *
 * @returns
 */
export function SubstructureScrollRestoreBehavior(props) {
    const { instancePath } = props;
    const divRef = useRef(null);
    const [isMatch, remove] = useConfigurationNavigationMatch({ instancePath });
    useEffect(() => {
        if (isMatch) {
            // use the element from the ref
            const element = divRef.current;
            if (element) {
                // and scroll to it
                element.scrollIntoView();
                // remove the marker so we don't scroll to it again
                remove();
            }
        }
    }, [divRef, isMatch, remove]);
    return (_jsx("div", { ref: divRef, className: "substructure-scroll-restore-behavior", id: instancePath }));
}
//# sourceMappingURL=SubstructureScrollRestoreBehavior.js.map